import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function ChevronDownIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <g id="chevron_down">
                <path id="vector" d="M2 8.025L3.775 6.25L12 14.475L20.225 6.25L22 8.025L12 18.025L2 8.025Z" />
            </g>
        </SvgIcon>
    );
}
